import { useAuth0 } from "@auth0/auth0-react";
import { CssBaseline } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { Link } from "react-router";

import NavBarDropdown from "@/components/Navbar/NavbarComponents/NavBarDropdown";
import { useNavLinks } from "@/components/Navbar/useNavLinks";
import logo from "@/img/logo.svg";
import "@/components/Navbar/Navbar.css";

export default function Navbar() {
  const { user } = useAuth0();
  const userLinks = useNavLinks(user);

  return (
    <nav id="main-navbar">
      <Box sx={{ flexGrow: 1 }}>
        <CssBaseline />
        <AppBar position="static">
          <Toolbar className="navbar-toolbar">
            <div className="navbar-left-section">
              <img
                src={logo}
                alt="SEIU"
                style={{ height: "30px", marginRight: "30px" }}
              />
              <Box sx={{ display: { xs: "none", sm: "none", md: "block" } }}>
                <div className="main-navbar-links">
                  {userLinks &&
                    userLinks.horizontalLinks.map((link) => (
                      <Link to={link.url} key={link.url}>
                        {link.name}
                      </Link>
                    ))}
                </div>
              </Box>
            </div>

            <div className="navbar-right-section main-navbar-links">
              <Box className="navbar-affiliate-name">
                <Typography
                  className="navbar-element affiliate-name"
                  variant="overline"
                >
                  <span>{user.org_name}</span>
                </Typography>
              </Box>
              <NavBarDropdown />
            </div>
          </Toolbar>
        </AppBar>
      </Box>
    </nav>
  );
}
